import { Text } from "@imminently/react/ui/core/text";
import { Stack } from "@mui/material";
import type { PatientEncounter } from "@/resources/types";
import React from "react";


export type DelegatesProps = {
  delegates: PatientEncounter["delegates"];
}

export const Delegates: React.FC<DelegatesProps> = React.memo(p => {
  const { delegates } = p;
  return (
    <>
      {
        delegates.map((it, i) => {
          const isAccompanyingPerson = (it as any).canAct === false;
          console.log('it', it);
          const label = isAccompanyingPerson ? "ACCOMPANYING PERSON" : "DELEGATE";
          const name = [it.firstName, it.lastName].filter(Boolean).join(" ") || "Unknown";
          return (
            <React.Fragment key={it.id}>
              <Stack py={1}>
                <Text variant="h6">{label} № {i + 1}</Text>
                <Text variant="body2">{name}</Text>
              </Stack>
              <Stack py={1}>
                <Text variant="h6">{label} № {i + 1} PHONE</Text>
                <Text variant="body2">{(it.phone_number || (it as any).phone) || "None"}</Text>
              </Stack>
              <Stack py={1}>
                <Text variant="h6">{label} № {i + 1} EMAIL</Text>
                <Text variant="body2">{it.email || "None"}</Text>
              </Stack>
            </React.Fragment>
          );
        })
      }
    </>
  );
});
Delegates.displayName = "PatianetDetailBlock/Delegates";
